<div class="row">

  <div class="col-12">

    <div class="card">

      <div class="card-header">
        <div class="title">{{ 'PRODUCT.PRODUCT_INFO' | translate }}</div>
        <div class="tools">

          <button type="button" class="btn btn-light btn-sm btn-back"  onClick="history.back()">
            <!-- <i class="bi bi-arrow-left-square"></i> -->
            {{ 'BACK' | translate }}
          </button>

          <!-- <app-change-state (updateEvent)="getBasisInfo()"  [_objectData]="{productsData: productsData, module: 'products'}"></app-change-state> -->

          <button *ngIf="id" type="button" class="btn btn-primary btn-sm btn-create" (click)="toProfile()">
              <!-- <i class="bi bi-eye"></i> -->
             {{ 'PRODUCT.PRODUCT_PROFILE' | translate }}
          </button>

          <button type="button" class="btn btn-primary btn-sm btn-create" (click)="onUpdate()">
            <!-- <i class="bi bi-save"></i> -->
             {{ 'SAVE' | translate }}
          </button>
        

        </div>
      </div>

      <div class="card-body">

        <app-addinfo [doAction]="addinfoAction"></app-addinfo>

      </div>

    </div>

  </div>
</div>